import React from 'react';
import { motion } from 'framer-motion';
import { Divider } from './Divider';
import { useLanguage } from '../data/i18n';
export function Truth() {
  const {
    lang,
    t
  } = useLanguage();
  return <section id="experiencia" className="relative w-full bg-black py-24 sm:py-32" data-id="element-218" data-mp="22avuxpz90avh">
      <div className="mx-auto max-w-3xl px-6 text-center" data-id="element-219" data-mp="27agpzpbarz2x">
        <Divider data-id="element-220" data-mp="27c1kjexm3i0s" />
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="mt-8 font-display text-4xl sm:text-6xl tracking-[0.05em] text-bone" data-id="element-221" data-mp="278dvot343jse">
          {t.truth.title}
        </motion.h2>

        <div key={lang} className="mt-10 space-y-6" data-id="element-222" data-mp="2q17yyprdhngs">
          {t.truth.lines.map((line, i) => <motion.p key={line} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.6,
          delay: 0.1 * i
        }} className="font-body text-base sm:text-lg font-light leading-relaxed text-white/70" data-id="element-223" data-mp="2v0udd2ixt9r6" data-mpi={i}>
              {line}
            </motion.p>)}
        </div>

        <p className="mt-12 font-display text-3xl sm:text-4xl tracking-[0.2em] text-bone" data-id="element-224" data-mp="2pwmx0wrc8wlf">{t.truth.kicker}</p>
      </div>
    </section>;
}